import React from 'react';

export default function OnboardingFormSubmitIcon() {
  return (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <mask
        id='mask0_43989_109822'
        style={{ maskType: 'alpha' }}
        maskUnits='userSpaceOnUse'
        x='0'
        y='0'
        width='24'
        height='25'
      >
        <rect y='0.00317383' width='24' height='24' fill='#D9D9D9' />
      </mask>
      <g mask='url(#mask0_43989_109822)'>
        <path
          d='M5.31556 18.9902H18.7001C18.7899 18.9902 18.8636 18.9614 18.9213 18.9037C18.979 18.8461 19.0078 18.7723 19.0078 18.6825V9.70949L14.2886 4.99023H5.31556C5.22573 4.99023 5.15198 5.01907 5.09431 5.07673C5.03665 5.1344 5.00781 5.20815 5.00781 5.29798V18.6825C5.00781 18.7723 5.03665 18.8461 5.09431 18.9037C5.15198 18.9614 5.22573 18.9902 5.31556 18.9902ZM5.31556 20.4902C4.8169 20.4902 4.3909 20.3137 4.03756 19.9605C3.6844 19.6072 3.50781 19.1812 3.50781 18.6825V5.29798C3.50781 4.79932 3.6844 4.37332 4.03756 4.01998C4.3909 3.66682 4.8169 3.49023 5.31556 3.49023H14.9021L20.5078 9.09598V18.6825C20.5078 19.1812 20.3312 19.6072 19.9781 19.9605C19.6247 20.3137 19.1987 20.4902 18.7001 20.4902H5.31556ZM7.25781 16.4902H16.7578V14.9902H7.25781V16.4902ZM7.25781 12.7402H16.7578V11.2402H7.25781V12.7402ZM7.25781 8.99023H13.6231V7.49023H7.25781V8.99023Z'
          fill='#195EFF'
        />
      </g>
    </svg>
  );
}
